import { labelStyle, groupStyle, focusStyle } from "./fieldStyles";

const SelectField = ({ formik, formClass, label, valueName, style, children }) => {
  return (
    <div style={{ ...groupStyle, ...style }}>
      <style>{focusStyle}</style>
      {label && <label htmlFor={valueName} style={labelStyle}>{label}</label>}
      <select
        id={valueName}
        className={`field-modern${formik.errors[valueName] ? " is-invalid" : ""}`}
        name={valueName}
        value={formik.values[valueName] ?? ""}
        onChange={(e) => formik.setFieldValue(valueName, e.target.value)}
      >
        {children}
      </select>
      {formik.errors[valueName] && (
        <span style={{ fontSize: "0.75rem", color: "#c62828", marginTop: "3px" }}>{formik.errors[valueName]}</span>
      )}
    </div>
  );
};

export default SelectField;
